<template>
    <div class="modal-overlay" @click.self="$emit('close')">
        <div class="modal-content">
            <div class="modal-scroll-wrapper">
                <div class="section">
                    <label class="section-label">Model</label>
                    <div class="section-content"><strong>{{ trailer.name }}</strong></div>
                </div>

                <div class="section">
                    <label class="section-label">Specyfikacja</label>
                    <div class="section-content">
                        <p><strong>Wymiar:</strong> {{ trailer.width }} x {{ trailer.height }} cm</p>
                        <p><strong>Masa własna:</strong> {{ trailer.weight }} kg</p>
                        <p><strong>Dopuszczalna masa całkowita:</strong> {{ trailer.dmc }} kg</p>
                    </div>
                </div>

                <div class="section">
                    <label class="section-label">Opis</label>
                    <div class="section-content">{{ trailer.description }}</div>
                </div>

                <div class="section" v-if="groupedAddons.length">
                    <label class="section-label">Wyposażenie standardowe</label>
                    <div class="section-content">
                        <div class="config-grid">
                            <div class="config-item" v-for="(option, index) in groupedAddons" :key="index">
                                <div class="config-icon">
                                    <font-awesome-icon icon="check-circle" size="lg" />
                                </div>
                                <span>{{ option }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-buttons">
                <button class="modal-button secondary" @click="$emit('close')">Zamknij</button>
                <button class="modal-button primary" @click="goToConfigurator">Przejdź do konfiguracji</button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    useTrailerStore
} from '@/stores/trailerStore'

export default {
    props: {
        trailer: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            trailerStore: useTrailerStore()
        }
    },
    computed: {
        groupedAddons() {
            const groups = new Set()
            this.trailerStore.moreDetailedTrailerAddons.forEach(addon => {
                const group = typeof addon.group === 'object' ? addon.group?.name : addon.group
                if (group) {
                    groups.add(group)
                }
            })
            return Array.from(groups)
        }
    },
    methods: {
        goToConfigurator() {
            this.trailerStore.selectTrailer(this.trailer)
            this.$router.push('/configurator')
        }
    }
}
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    padding: 20px;
}

.modal-content {
    background-color: $color-white;
    border-radius: 10px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-scroll-wrapper {
    overflow-y: auto;
    max-height: 100%;
    padding: 30px;
    box-sizing: border-box;
    scrollbar-gutter: stable;
}

.section {
    margin-bottom: 20px;
}

.section-label {
    font-weight: 600;
    color: $color-primary;
    font-size: 1rem;
    display: block;
    margin-bottom: 15px;
}

.section-content {
    color: $color-text;
    font-size: 0.95rem;
    text-align: justify;
}

.config-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 10px;
}

.config-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    background-color: rgba($color-primary, 0.1);
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        background-color: rgba($color-primary, 0.2);
        transform: translateY(-2px);
    }
}

.config-icon {
    color: $color-primary;
    display: flex;
    align-items: center;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding: 20px 30px;
    border-top: 1px solid $color-grey-light;
    background-color: $color-white;
    flex-shrink: 0;
    flex-wrap: wrap;
}

.modal-button {
    flex: 1 1 0;
    padding: 12px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    min-width: 0;

    &.primary {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }
    }

    &.secondary {
        background-color: $color-grey-light;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@media (max-width: 576px) {
    .modal-buttons {
        flex-direction: column-reverse;
    }

    .modal-button {
        width: 100%;
    }
}
</style>